import { useQuery } from '@tanstack/react-query';
import { getGeocode, getLatLng } from 'use-places-autocomplete';

const getAddressGeometry = async (address: string) => {
  const geocode = await getGeocode({ address });

  return getLatLng(geocode[0]);
};

export function useAddressGeometryQuery(address?: string) {
  const { data, isLoading } = useQuery({
    queryFn: () => getAddressGeometry(address!),
    queryKey: ['useAddressGeometryQuery', address],
    enabled: Boolean(address),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
  });

  return { data, isLoading };
}
